import React from 'react';
import ColorTag from '../ColorTag/ColorTag';

interface ColorTagLiveProps {}

const ColorTagLive: React.FC<ColorTagLiveProps> = props => {
  return <ColorTag className="ColorTagLive" color="red">Live</ColorTag>
}

export default ColorTagLive;